import { apiClient } from '@app/lib'
import { type SugarRosterFundingResponse, type SugarRosterFundingUpsert } from '@app/types'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { some } from 'lodash'

export const useUpdateRosterFunding = () => {
  const queryClient = useQueryClient()
  const { isPending, mutateAsync } = useMutation({
    mutationFn: async (input: SugarRosterFundingUpsert) => {
      const { data } = await apiClient.post<SugarRosterFundingResponse>('/api/roster/funding', input)

      return data
    },
    onSuccess: (data) => {
      // `success` stays true even when every item was rejected, so refetch only
      // once an item actually persisted.
      if (some(data.data, 'saved')) {
        queryClient.invalidateQueries({
          queryKey: ['enrollments']
        })
      }
    }
  })

  return {
    isUpdatingRosterFunding: isPending,
    updateRosterFunding: mutateAsync
  }
}
